import React from "react";

export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-border/60 ${className}`} />;
}

export function EmptyState({
  title,
  hint,
  icon: Icon,
}: {
  title: string;
  hint?: string;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-xl gap-xs text-textLight">
      {Icon && <Icon size={28} className="text-textLight/60" />}
      <div className="text-sm font-medium text-text">{title}</div>
      {hint && <div className="text-xs">{hint}</div>}
    </div>
  );
}
